const LOGOUT_URL = '/user/auth/logout';

const REDUCER_MENU_NAME = 'menu';

export {
  LOGOUT_URL,

  REDUCER_MENU_NAME,
};
